import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { App } from '@df/core/app';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NToggle } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import flatten from 'lodash-es/flatten';
import { NCustomerGroups } from '../../../../../customer/groups/customer-groups';
import { CustomerGroupsService } from '../../../../../customer/groups/customer-groups.service';
import { CsOverrideIdDirective } from '../../../../../layout/meganav/cs-override-id.directive';
import { GtmTrackClickDirective } from '../../../../../module/gtm/gtm-track-click.directive';
import { config } from './submenu.config';
import { IPageComponentSubmenuBlockData, IPageComponentSubmenuData } from './submenu.interface';

@Component({
    selector: 'page-component-submenu',
    templateUrl: './submenu.html',
    styleUrl: './submenu.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        CsOverrideIdDirective,
        DfImageDirective,
        GridModule,
        GtmTrackClickDirective,
        HrefComponent,
        ICmsClientModule,
        ToggleModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentSubmenuComponent>(config)
export class PageComponentSubmenuComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentSubmenuData;

    outletOptions?: {
        context: {
            toggleGroupId?: NToggle.TId;
            tabName?: string;
        };
    };

    private blocksIndex: IPageComponentSubmenuBlockData[] = [];

    protected app = inject(App);
    protected customerGroupsService = inject(CustomerGroupsService);

    override ngOnInit(): void {
        super.ngOnInit();

        this.updateBlocksIndex();
        this.subscriptions.add(this.app.customer.model.obs.status.subscribe(() => this.updateBlocksIndex()));
    }

    getIndex(block: IPageComponentSubmenuBlockData) {
        const index = this.blocksIndex.indexOf(block);

        return index > -1 ? index : 0;
    }

    ifCustomerGroup(value: NCustomerGroups.TId | NCustomerGroups.TId[]): boolean {
        return this.customerGroupsService.isAllowed(value);
    }

    protected updateBlocksIndex() {
        this.blocksIndex =
            flatten(this.component?.columns?.filter(column => this.ifCustomerGroup(column.visibility)).map(column => column.blocks)).filter(
                block => this.ifCustomerGroup(block.visibility)
            ) || [];

        this.detectChanges();
    }
}
